import { portal } from '../../assets/plugins/axios/axios.js';
import { AxiosError } from 'axios';
import { HttpError } from '../../../src/business/httpError';
import { MunicipalityModel } from '../../models/municipality.model';
import { InstitutionDtoModel } from '../../models/institutionDto.model';

class GenericAdminService {
  public getMunicipalities = async (): Promise<MunicipalityModel[]> => {
    try {
      const { data } = await portal.get('?method=genericAdmin.getMunicipalities');
      return data.data;
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };
  public getInstitutions = async (): Promise<InstitutionDtoModel[]> => {
    try {
      const { data } = await portal.get('?method=genericAdmin.getInstitutions');
      return data.data;
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };
}

export const genericAdminService = new GenericAdminService();
